import { inspectRpcResponse, isKnownNearRpcUrl } from "../utils/nearRpc";

function requestUrl(input) {
  if (typeof input === "string") return input;
  if (typeof URL !== "undefined" && input instanceof URL) return input.toString();
  return input?.url || "";
}

function transientResponse(status = 503) {
  return new Response("NEAR RPC temporarily unavailable", {
    status,
    headers: { "Content-Type": "text/plain; charset=utf-8" },
  });
}

export function createNearRpcFetch(fetchImpl) {
  return async (input, init) => {
    const response = await fetchImpl(input, init);
    if (!isKnownNearRpcUrl(requestUrl(input))) return response;

    const inspected = await inspectRpcResponse(response);
    if (inspected.kind === "OK" || !inspected.transient) return response;

    // Wibe3 1.0.27 rotates its built-in NEAR provider list only after a
    // network/HTTP failure. Preserve the requested provider URL and convert
    // transient JSON-RPC 200 responses (notably FastNEAR -429), malformed
    // bodies, and empty bodies into an HTTP failure so Wibe3 advances to the
    // next provider instead of surfacing a raw provider error.
    if (response.status === 429 || response.status >= 500) return response;
    return transientResponse(inspected.status === 429 ? 429 : 503);
  };
}

let patched = false;

export function patchNearRpcFetch() {
  if (patched || typeof window === "undefined" || typeof window.fetch !== "function") return;
  const descriptor = Object.getOwnPropertyDescriptor(window, "fetch");
  if (descriptor && descriptor.writable === false) return;

  const originalFetch = window.fetch.bind(window);
  try {
    window.fetch = createNearRpcFetch(originalFetch);
    patched = true;
  } catch {
    // Locked-down runtimes keep the native fetch path.
  }
}
